import { BaseNavBar } from "@/components/nav/BaseNavBar";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_standard")({
  component: StandardLayout,
});

function StandardLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <BaseNavBar />
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
